import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getAllStore,
  createStore,
  updateStore,
  duplicate,
  deleteStore,
} from "../../reducers/store";

import "./Mystores.css";
import { ReactComponent as HouseIcon } from "../../icons/house-bold.svg";
import { ReactComponent as Check } from "../../icons/check-circle-bold.svg";
import { ReactComponent as Plus } from "../../icons/plus-circle-bold.svg";

import { Input } from "../../components/forms/Form";
import CreateStoreModal from "./createStoreModal";
import ModifyStoreModal from "./modifyStoreModal";
import DeleteStoreModal from "./deleteStoreModal";
import Item from "../mystores/MystoreItem";

import img1 from "../../images/placeholder-home (1).png";

import "../../App.css";

class Mystores extends Component {
  state = {
    q: "",
    showCreateFormPopUp: false,
    showModifyFormPopUp: false,
    showDeleteFormPopUp: false,
    editingStore: {},
  };
  async componentDidMount() {
    await this.props.getAllStore();
  }

  _handleCreateSubmit = async () => {
    const { siteName, siteCompanyName, siteHostname } = this.state;
    await this.props.createStore({ siteName, siteCompanyName, siteHostname });
    this.setState({ showCreateFormPopUp: false });
  };

  _handleModifySubmit = async () => {
    const { siteName, siteCompanyName, siteHostname } = this.state;
    await this.props.updateStore(this.state.editingStore.storeId, {
      siteName,
      siteCompanyName,
      siteHostname,
    });
    this.setState({ showModifyFormPopUp: false });
  };
  _handleDeleteSubmit = () => {
    this.props.deleteStore(this.state.editingStore.storeId);
    this.setState({ showDeleteFormPopUp: false });
  };

  _handleDuplicate = (storeId) => {
    this.props.duplicate(storeId);
  };

  _handleChangeInput = (target, value) => {
    this.setState({
      [target]: value,
    });
  };

  _toggleCreateFormPopUp = () =>
    this.setState({ showCreateFormPopUp: !this.state.showCreateFormPopUp });

  _toggleDeleteFormPopUp = (value) => {
    this.setState({ showDeleteFormPopUp: !this.state.showDeleteFormPopUp });
    if (!value) {
      this.setState({
        editingStore: {},
        siteName: null,
        siteCompanyName: null,
        siteHostname: null,
      });
    } else {
      this.setState({
        editingStore: value,
      });
    }
  };

  _toggleModifyFormPopUp = (value) => {
    this.setState({
      showModifyFormPopUp: !this.state.showModifyFormPopUp,
    });
    if (!value) {
      this.setState({
        editingStore: {},
        siteName: null,
        siteCompanyName: null,
        siteHostname: null,
      });
    } else {
      this.setState({
        editingStore: value,
      });
    }
  };

  // _setEditingStore = (value) => this.setState({ editingStore: value });

  _isDisabled = () => {
    const inputsSite = [
      { target: "siteName" },
      { target: "siteCompanyName" },
      { target: "siteHostname" },
    ];
    const inputStatus = inputsSite.map(
      (input) => !!this.state[input.target] && this.state[input.target] !== ""
    );
    return typeof inputStatus.find((input) => !input) !== "undefined";
  };

  _isModifyButtonDisabled = () => {
    const oldStore = this.props.stores.find(
      (store) => store.id === this.state.editingStore.id
    );
    const inputsSite = [
      { target: "siteName" },
      { target: "siteCompanyName" },
      { target: "siteHostname" },
    ];
    const inputStatus = inputsSite.map(
      (input) =>
        !!this.state[input.target] &&
        this.state[input.target] !== "" &&
        this.state[input.target] !== oldStore[input.target]
    );
    const inputAreValid =
      typeof inputStatus.find((input) => !!input) !== "undefined";

    return !inputAreValid;
  };

  render() {
    // console.log(this.state);
    return (
      <div id="stores-container">
        {this.state.showCreateFormPopUp && (
          <CreateStoreModal
            loading={this.props.loading}
            togglePopUp={this._toggleCreateFormPopUp}
            handleChangeInput={this._handleChangeInput}
            error={this.props.error}
            handleSubmit={this._handleCreateSubmit}
            title={"Crea Nuovo Sito"}
            disabled={this._isDisabled}
          />
        )}
        {this.state.showModifyFormPopUp && (
          <ModifyStoreModal
            loading={this.props.loading}
            togglePopUp={this._toggleModifyFormPopUp}
            handleChangeInput={this._handleChangeInput}
            editingStore={this.state.editingStore}
            error={this.props.error}
            handleSubmit={this._handleModifySubmit}
            title={"Modifica Dati Sito"}
            disabled={this._isModifyButtonDisabled}
          />
        )}
        {this.state.showDeleteFormPopUp && (
          <DeleteStoreModal
            loading={this.props.loading}
            togglePopUp={this._toggleDeleteFormPopUp}
            editingStore={this.state.editingStore}
            handleSubmit={this._handleDeleteSubmit}
            title={"Elimina Sito"}
          />
        )}

        <div className="my-sites">
          <div className="description">
            <div className="description-title">
              <HouseIcon style={{ height: "56px" }} />
              <h1>I miei siti</h1>
            </div>
            <p>
              Seleziona un sito da modificare, visualizzalo e apri il pannelo di
              controllo.
            </p>
          </div>
          <button onClick={this._toggleCreateFormPopUp} className="white">
            <Plus />
            <span>Crea un nuovo sito</span>
          </button>
        </div>
        {this.props.stores.length ? (
          <div id="stores-items-container">
            <div className="header-stores-items">
              <h4>Tutti i siti</h4>
              <Input
                handleChangeInput={this._handleChangeInput}
                target="q"
                type="text"
                placeholder="Cerca..."
              />
            </div>
            <div className="list-stores">
              {this.props.stores
                .filter((store) => {
                  return (
                    store.siteName.toLowerCase().includes(this.state.q) ||
                    store.siteCompanyName
                      .toLowerCase()
                      .includes(this.state.q) ||
                    store.siteHostname.toLowerCase().includes(this.state.q)
                  );
                })
                .map((store, idx) => (
                  <Item
                    handleDuplicate={this._handleDuplicate}
                    setEditingStore={this._setEditingStore}
                    toggleModifyPopUp={this._toggleModifyFormPopUp}
                    toggleDeletePopUp={this._toggleDeleteFormPopUp}
                    showEdit={true}
                    previewUrl={"/preview"}
                    background={store.brandColor}
                    id={store.storeId}
                    nome={store.siteName}
                    key={idx}
                    store={store}
                  />
                ))}
            </div>
          </div>
        ) : (
          <div id="no-store">
            <div className="no-store-image">
              <img src={img1} alt="no-store-illustration" />
            </div>
            <div className="no-store-description">
              <h2>Crea il tuo primo eCommerce per la Farmacia</h2>
              <ul>
                <li>
                  <Check />
                  Scegli più di 30 combinazioni
                </li>
                <li>
                  <Check />
                  Dominio personale
                </li>
                <li>
                  <Check />
                  Template sempre aggiornati
                </li>
                <li>
                  <Check />
                  Editor visuale
                </li>
              </ul>
              <button  onClick={this._toggleCreateFormPopUp} >
                <Plus />
                <span>Crea un nuovo sito</span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  stores: state.store.data,
  loading: state.store.loading,
  error: state.store.error,
});

export default connect(mapStateToProps, {
  getAllStore,
  createStore,
  updateStore,
  duplicate,
  deleteStore,
})(Mystores);
